import React from "react";
import PropTypes from "prop-types";

import { CopyText } from "../CopyText";
import { A11yText } from "../A11yText";

import styles from "./RadioButton.scss";

function RadioButtonLegend({ variants, a11y, children }) {
  return a11y ? (
    <A11yText tag="legend">{children}</A11yText>
  ) : (
    <CopyText tag="legend" customClass={styles.legend} variants={variants}>
      {children}
    </CopyText>
  );
}

RadioButtonLegend.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  variants: PropTypes.string,
  a11y: PropTypes.bool,
};

RadioButtonLegend.defaultProps = {
  variants: CopyText.Variant.additional,
  a11y: false,
};

RadioButtonLegend.displayName = "RadioButton.Legend";

export default RadioButtonLegend;
